module.exports = __webpack_public_path__ + "img/nested.ae025f30.svg";